import React, { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';


const Sidebar = () => {

  const user = useSelector((state) => state.user);
  const userRole = user?.role || localStorage.getItem('role');
  const userPermissions =
    user?.permissions ||
    JSON.parse(localStorage.getItem("permissions") || "[]");



  const hasPermission = (key) =>
    userRole === 'admin' || userPermissions.includes(key);
  const location = useLocation();
  const [openMenus, setOpenMenus] = useState({
    reports: false,
    organizations: false
  });


  // Check if route is active
  const isActive = useCallback(
    (path) => location.pathname === path || location.pathname.startsWith(path + '/'),
    [location.pathname]
  );

  // Check if any child route is active
  const isMenuActive = useCallback(
    (paths) => paths.some((path) => isActive(path)),
    [isActive]
  );

  // Toggle menu open/close
  const toggleMenu = (menuName) => {
    setOpenMenus((prev) => ({ ...prev, [menuName]: !prev[menuName] }));
  };

  // Auto-open menu if child route is active
  useEffect(() => {
    if (isMenuActive(['/user-report', '/leads-report', '/interested-user'])) {
      setOpenMenus((prev) => ({ ...prev, reports: true }));
    }
    if (isMenuActive(['/subscription', '/category', '/role'])) {
      setOpenMenus((prev) => ({ ...prev, organizations: true }));
    }
  }, [isMenuActive]);

  return (
    <aside className="main-sidebar sidebar-dark-primary elevation-4">
      <Link to="/" className="brand-link logo-switch">
        <img src="/assets/img/color icon_circle.png" alt="GeoHunt360" className="brand-image-xl logo-xs" />
        <img src="/assets/img/color icon_circle.png" alt="GeoHunt360" className="brand-image-xs logo-xl" />
      </Link>

      <div className="sidebar">
        <nav className="mt-2">
          <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">

            {hasPermission('dashboard') && (
              <li className="nav-item">
                <Link to="/dashboard" className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`}>
                  <svg className="nav-icon" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <rect x="3" y="3" width="8" height="8" rx="2" />
                    <rect x="13" y="3" width="8" height="8" rx="2" />
                    <rect x="3" y="13" width="8" height="8" rx="2" />
                    <rect x="13" y="13" width="8" height="8" rx="2" />
                  </svg>
                  <p>Dashboard</p>
                </Link>
              </li>
            )}

            {hasPermission('invite_users') && (
              <li className="nav-item">
                <Link to="/invite" className={`nav-link ${isActive('/invite') ? 'active' : ''}`}>
                  <i className="nav-icon fa-solid fa-users" />
                  <p>Invite Users</p>
                </Link>
              </li>
            )}

            {hasPermission('leads') && (
              <li className="nav-item">
                <Link to="/content" className={`nav-link ${isActive('/content') ? 'active' : ''}`}>
                  <i className="nav-icon fa-solid fa-bullhorn" />
                  <p>Leads</p>
                </Link>
              </li>
            )}

            {hasPermission('customer_master') && (
              <li className="nav-item">
                <Link to="/customer-master" className={`nav-link ${isActive('/customer-master') ? 'active' : ''}`}>
                  <i className="nav-icon fa-solid fa-building" />
                  <p>Customer Master</p>
                </Link>
              </li>
            )}

            {/* Reports Menu */}
            {(hasPermission('user_report') || hasPermission('leads_report') || hasPermission('payment') || hasPermission('interested_user')) && (
              <li className={`nav-item ${openMenus.reports ? 'menu-open' : ''}`}>
                <Link
                  to="#"
                  className={`nav-link ${isMenuActive(['/user-report', '/leads-report', '/interested-user']) ? 'active' : ''}`}
                  onClick={(e) => { e.preventDefault(); toggleMenu('reports'); }}
                >
                  <i className="nav-icon fa-solid fa-id-card-clip" />
                  <p>
                    Reports
                    <i className="right fas fa-angle-left" />
                  </p>
                </Link>
                <ul className="nav nav-treeview" style={{ display: openMenus.reports ? 'block' : 'none' }}>
                  {hasPermission('user_report') && (
                    <li className="nav-item">
                      <Link to="/user-report" className={`nav-link ${isActive('/user-report') ? 'active' : ''}`}>
                        <i className="far fa-circle nav-icon" />
                        <p>User Reports</p>
                      </Link>
                    </li>
                  )}
                  {hasPermission('leads_report') && (
                    <li className="nav-item">
                      <Link to="/leads-report" className={`nav-link ${isActive('/leads-report') ? 'active' : ''}`}>
                        <i className="far fa-circle nav-icon" />
                        <p>Leads Reports</p>
                      </Link>
                    </li>
                  )}
                    {hasPermission('payment') && (
                    <li className="nav-item">
                      <Link to="/payment" className={`nav-link ${isActive('/payment') ? 'active' : ''}`}>
                        <i className="far fa-circle nav-icon" />
                        <p>Payment Report</p>
                      </Link>
                    </li>
                  )}
                  {hasPermission('interested_user') && (
                    <li className="nav-item">
                      <Link to="/interested-user" className={`nav-link ${isActive('/interested-user') ? 'active' : ''}`}>
                        <i className="far fa-circle nav-icon" />
                        <p>Category Interested Users</p>
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}

             {/* <li className="nav-item">
              <Link to="#" className="nav-link">
                <i className="nav-icon fa-solid fa-cart-shopping" />
                <p>
                  My Military Insider
                  <i className="right fas fa-angle-left" />
                </p>
              </Link>
              <ul className="nav nav-treeview">
                <li className="nav-item">
                  <Link to="/dashboard" className="nav-link">
                    <i className="far fa-circle nav-icon" />
                    <p>Dashboard</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/report" className="nav-link">
                    <i className="far fa-circle nav-icon" />
                    <p>Brands</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/report" className="nav-link">
                    <i className="far fa-circle nav-icon" />
                    <p>Products</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/department" className="nav-link">
                    <i className="far fa-circle nav-icon" />
                    <p>Category</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/designation" className="nav-link">
                    <i className="far fa-circle nav-icon" />
                    <p>Category Mapping</p>
                  </Link>
                </li>
              </ul>
            </li>  */}

            {/* Organizations Menu */}
            {(hasPermission('subscription') || hasPermission('category') || hasPermission('role')) && (
              <li className={`nav-item ${openMenus.organizations ? 'menu-open' : ''}`}>
                <Link
                  to="#"
                  className={`nav-link ${isMenuActive(['/subscription', '/category', '/role']) ? 'active' : ''}`}
                  onClick={(e) => { e.preventDefault(); toggleMenu('organizations'); }}
                >
                  <i className="nav-icon fa-solid fa-id-card-clip" />
                  <p>
                    Organizations
                    <i className="right fas fa-angle-left" />
                  </p>
                </Link>
                <ul className="nav nav-treeview" style={{ display: openMenus.organizations ? 'block' : 'none' }}>
                  {hasPermission('subscription') && (
                    <li className="nav-item">
                      <Link to="/subscription" className={`nav-link ${isActive('/subscription') ? 'active' : ''}`}>
                        <i className="far fa-circle nav-icon" />
                        <p>Subscription Plans</p>
                      </Link>
                    </li>
                  )}
                  {hasPermission('category') && (
                    <li className="nav-item">
                      <Link to="/category" className={`nav-link ${isActive('/category') ? 'active' : ''}`}>
                        <i className="far fa-circle nav-icon" />
                        <p>Category</p>
                      </Link>
                    </li>
                  )}
                  {hasPermission('role') && (
                    <li className="nav-item">
                      <Link to="/role" className={`nav-link ${isActive('/role') ? 'active' : ''}`}>
                        <i className="far fa-circle nav-icon" />
                        <p>Role</p>
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}

          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default Sidebar;